<template>
  <div class="detail-page">

    <!-- ===== 01. 메인 비주얼 ===== -->
    <section class="dp-hero">
      <img :src="require('@/assets/1.png')" alt="메인 비주얼 1" class="dp-hero-img" />
      <img :src="require('@/assets/2.png')" alt="메인 비주얼 2" class="dp-hero-img" />
    </section>

    <!-- ===== 프리미엄 TOP6 ===== -->
    <section class="sec sec-premium">
      <div class="prem-head">
        <p class="prem-eyebrow">CASTLE PREMIUM TOP 6</p>
        <h2 class="prem-title">평촌 프리미엄의<br/><strong>새로운 기준</strong></h2>
        <div class="prem-title-line"></div>
      </div>

      <div class="prem-list">
        <article
          class="prem-item"
          :class="{ 'is-right': idx % 2 === 1 }"
          v-for="(item, idx) in premiumItems"
          :key="idx"
        >
          <span class="prem-num">{{ String(idx + 1).padStart(2, '0') }}</span>
          <div class="prem-content">
            <p class="prem-cat">{{ item.cat }}</p>
            <h3 class="prem-headline" v-html="item.headline"></h3>
            <p class="prem-desc" v-html="item.desc"></p>
          </div>
        </article>
      </div>
    </section>

    <!-- ===== 입지환경 ===== -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">LOCATION</p>
        <h2 class="section-title">입지환경</h2>
      </div>
      <img :src="require('@/assets/입지환경.jpg')" alt="입지환경" class="community-img" />
      <img :src="require('@/assets/입지환경2.png')" alt="입지환경" class="community-img" />
    </section>

    <!-- ===== 단지배치도 ===== -->
    <section class="sec sec-layout">
      <div class="sec-inner">
        <p class="sec-eyebrow">UNIT LAYOUT</p>
        <h2 class="section-title">단지배치도</h2>
      </div>
      <img :src="require('@/assets/동호배치도.png')" alt="단지배치도" class="layout-img" />
    </section>

    <!-- ===== 세대정보 ===== -->
    <section class="sec sec-unit">
      <div class="sec-inner">
        <p class="sec-eyebrow">UNIT PLAN</p>
        <h2 class="section-title">세대정보</h2>

        <!-- 유닛 타입 탭 (가로 스크롤) -->
        <div class="unit-tabs-wrap">
          <div class="unit-tabs">
            <button
              v-for="tab in unitTabs"
              :key="tab.id"
              class="unit-tab"
              :class="{ active: activeUnit === tab.id }"
              @click="activeUnit = tab.id"
            >
              <span class="unit-tab-label">{{ tab.label }}</span>
              <span v-if="tab.tag" class="unit-tab-tag">{{ tab.tag }}</span>
            </button>
          </div>
        </div>

        <!-- 활성 유닛 라벨 -->
        <div class="unit-current">
          <span class="unit-current-name">{{ activeUnit }}</span>
          <span v-if="activeUnitTag" class="unit-current-tag">{{ activeUnitTag }}</span>
        </div>

        <!-- 평면 이미지 -->
        <transition name="fade" mode="out-in">
          <div class="unit-stack" :key="activeUnit">
            <figure class="unit-figure" v-for="(img, i) in unitImages" :key="i">
              <img :src="img" :alt="`${activeUnit} 평면도 ${i + 1}`" class="unit-img" />
            </figure>
          </div>
        </transition>
      </div>
    </section>

    <!-- ===== 인테리어 ===== -->
    <section class="sec sec-unit">
      <div class="sec-inner">
        <p class="sec-eyebrow">INTERIOR</p>
        <h2 class="section-title">인테리어</h2>

        <!-- 인테리어 타입 탭 -->
        <div class="unit-tabs-wrap">
          <div class="unit-tabs">
            <button
              v-for="tab in interiorTabs"
              :key="tab.id"
              class="unit-tab"
              :class="{ active: activeInterior === tab.id }"
              @click="activeInterior = tab.id"
            >
              <span class="unit-tab-label">{{ tab.label }}</span>
            </button>
          </div>
        </div>

        <!-- 활성 타입 라벨 -->
        <div class="unit-current">
          <span class="unit-current-name">{{ activeInterior }}</span>
        </div>

        <!-- 인테리어 이미지 -->
        <transition name="fade" mode="out-in">
          <div class="unit-stack" :key="activeInterior">
            <figure class="unit-figure">
              <img :src="interiorImage" :alt="`${activeInterior} 인테리어`" class="unit-img" />
            </figure>
          </div>
        </transition>
      </div>
    </section>

    <!-- ===== 커뮤니티 ===== -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">COMMUNITY</p>
        <h2 class="section-title">커뮤니티</h2>
      </div>
      <img :src="require('@/assets/커뮤니티.jpg')" alt="커뮤니티" class="community-img" />
      <img :src="require('@/assets/커뮤니티2.jpg')" alt="커뮤니티" class="community-img" />
      <img :src="require('@/assets/커뮤니티3.jpg')" alt="커뮤니티" class="community-img" />
    </section>

    <!-- ===== 엘리스 주거서비스 ===== -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">ELYES</p>
        <h2 class="section-title">엘리스 주거서비스</h2>
      </div>
      <img :src="require('@/assets/elyes.jpg')" alt="엘리스 주거서비스" class="community-img" />
    </section>

    <!-- ===== 시스템 ===== -->
    <section class="sec sec-unit">
      <div class="sec-inner">
        <p class="sec-eyebrow">SYSTEM</p>
        <h2 class="section-title">시스템</h2>

        <!-- 시스템 타입 탭 -->
        <div class="unit-tabs-wrap">
          <div class="unit-tabs">
            <button
              v-for="tab in systemTabs"
              :key="tab.id"
              class="unit-tab"
              :class="{ active: activeSystem === tab.id }"
              @click="activeSystem = tab.id"
            >
              <span class="unit-tab-label">{{ tab.label }}</span>
            </button>
          </div>
        </div>

        <!-- 활성 타입 라벨 -->
        <div class="unit-current">
          <span class="unit-current-name">{{ activeSystemName }}</span>
        </div>

        <!-- 시스템 이미지 -->
        <transition name="fade" mode="out-in">
          <div class="unit-stack" :key="activeSystem">
            <figure class="unit-figure">
              <img :src="systemImage" :alt="activeSystemName" class="unit-img" />
            </figure>
          </div>
        </transition>
      </div>
    </section>

    <!-- ===== 10. 방문예약 ===== -->
    <section class="dp-register" ref="secRegister">
      <div class="dp-section-inner">
        <p class="dp-eyebrow light">CONTACT</p>
        <h2 class="dp-section-title light">방문예약</h2>
        <p class="dp-register-desc">상담을 원하시면 아래 정보를 입력해주세요.</p>

        <div v-if="!isSubmitted">
          <form @submit.prevent="submitForm" class="dp-form">
            <div class="dp-field">
              <label>이름 <span class="dp-req">*</span></label>
              <input type="text" v-model="formData.name" placeholder="이름을 입력해주세요" required />
            </div>
            <div class="dp-field">
              <label>연락처 <span class="dp-req">*</span></label>
              <div class="dp-phone">
                <input type="tel" inputmode="numeric" ref="p1" v-model="formData.phone1" placeholder="010" maxlength="3" required @input="onPhoneInput('phone1', 3, 'p2')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="p2" v-model="formData.phone2" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone2', 4, 'p3')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="p3" v-model="formData.phone3" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone3', 4, null)" />
              </div>
            </div>
            <div class="dp-field">
              <label>원하시는 방문일 <span class="dp-req">*</span></label>
              <div class="dp-date-stack">
                <div class="dp-date-wrap">
                  <input type="date" v-model="formData.visitDate" :min="todayStr"
                         :disabled="formData.consultLater" class="dp-date-input" />
                  <span v-if="!formData.visitDate && !formData.consultLater" class="dp-date-placeholder">📅 방문일 선택</span>
                </div>
                <select v-model="formData.visitTime" :disabled="formData.consultLater" class="dp-select">
                  <option value="" disabled>⏰ 방문시간 선택</option>
                  <option v-for="t in visitTimes" :key="t" :value="t">{{ t }}</option>
                </select>
              </div>
              <button type="button" class="dp-later-btn"
                      :class="{ active: formData.consultLater }"
                      @click="toggleConsultLater">상담 후 결정</button>
            </div>
            <label class="dp-agree">
              <input type="checkbox" v-model="formData.agree" required />
              <span class="dp-check"></span>
              <span>개인정보 수집 및 이용에 동의합니다.</span>
            </label>
            <button type="submit" class="dp-submit" :disabled="isSubmitting">
              {{ isSubmitting ? '전송 중...' : '방문예약 신청' }}
            </button>
          </form>
        </div>

        <div v-else class="dp-success">
          <div class="dp-success-icon">&#10003;</div>
          <h3>신청이 완료되었습니다</h3>
          <p>빠른 시일 내에 연락드리겠습니다.</p>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'MainView',
  data() {
    return {
      observers: [],
      activeUnit: '47A',
      activeInterior: '47A',
      activeSystem: '디지털',
      isSubmitting: false,
      isSubmitted: false,
      formData: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        visitDate: '',
        visitTime: '',
        consultLater: false,
        agree: false
      },
      visitTimes: [
        '10:00', '10:30', '11:00', '11:30',
        '12:00', '12:30', '13:00', '13:30',
        '14:00', '14:30', '15:00', '15:30',
        '16:00', '16:30', '17:00', '17:30'
      ],
      unitTabs: [
        { id: '47A', label: '47A', images: ['47A.jpg'] },
        { id: '84A', label: '84A', images: ['84A.jpg'] },
        { id: '84B', label: '84B', images: ['84B.jpg'] },
        { id: '84C', label: '84C', images: ['84C.jpg'] },
        { id: '96A', label: '96A', images: ['96A.jpg'] },
        { id: '118A', label: '118A', images: ['118A.jpg'] },
        { id: '118A-1', label: '118A-1', images: ['118A-1.jpg'] },
        { id: '119A', label: '119A', images: ['119A.jpg'] },
        { id: '119B', label: '119B', images: ['119B.jpg'] }
      ],
      interiorTabs: [
        { id: '47A', label: '47A', img: '47A인테리어.jpg' },
        { id: '84A', label: '84A', img: '84A인테리어.jpg' },
        { id: '118A', label: '118A', img: '118A인테리어.jpg' }
      ],
      systemTabs: [
        { id: '디지털', label: '디지털', name: '디지털 시스템', img: '디지털.jpg' },
        { id: '에너지', label: '에너지', name: '에너지 시스템', img: '에너지.jpg' },
        { id: '보안', label: '보안', name: '보안 시스템', img: '보안.jpg' },
        { id: '스마트홈', label: '스마트홈', name: '스마트홈 시스템', img: '스마트홈.jpg' },
        { id: '주차장', label: '주차장', name: '주차장 시스템', img: '주차장.jpg' },
        { id: '친환경', label: '친환경', name: '친환경 시스템', img: '친환경.jpg' }
      ],
      premiumItems: [
        {
          cat: 'EDUCATION',
          headline: '걸어서 누리는 명문 교육인프라',
          desc: '도보거리 귀인중, 백영고 및 단지 앞 평촌 학원가 등'
        },
        {
          cat: 'TRAFFIC',
          headline: '동탄인덕원선 농수산물도매시장역<br/>(\'29년 개통예정) 초역세권',
          desc: '시내·외 편리한 이동으로 서울 출퇴근 용이한'
        },
        {
          cat: 'INFRA',
          headline: '10분대로 만나는 중심 생활환경',
          desc: '롯데백화점, 롯데마트, 이마트, 성심병원,<br/>안양농수산물 도매시장 등'
        },
        {
          cat: 'NATURE',
          headline: '자연을 곁에 둔 도심 속 힐링특권',
          desc: '도보권에 위치한 평촌 중앙공원,<br/>자유공원 산책로 등'
        },
        {
          cat: 'VISION',
          headline: '평촌의 변화를 앞서 누릴 특급 비전',
          desc: '평촌 1기 신도시 선도지구(계획),<br/>안양 농수산물시장역(개통예정) 등'
        },
        {
          cat: 'BRAND',
          headline: '롯데캐슬 브랜드 독보적 프리미엄',
          desc: '교육특화 커뮤니티와 안양 NO.1 스카이뷰로<br/>더욱 빛나는'
        }
      ]
    }
  },
  computed: {
    unitImages() {
      const tab = this.unitTabs.find(t => t.id === this.activeUnit)
      if (!tab) return []
      return tab.images.map(name => require(`@/assets/unit/${name}`))
    },
    interiorImage() {
      const tab = this.interiorTabs.find(t => t.id === this.activeInterior)
      return tab ? require(`@/assets/${tab.img}`) : ''
    },
    activeSystemName() {
      return this.systemTabs.find(t => t.id === this.activeSystem)?.name || ''
    },
    systemImage() {
      const tab = this.systemTabs.find(t => t.id === this.activeSystem)
      return tab ? require(`@/assets/${tab.img}`) : ''
    },
    activeUnitTag() {
      return this.unitTabs.find(t => t.id === this.activeUnit)?.tag || ''
    },
    todayStr() {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    }
  },
  mounted() {
    this.setupReveal()
    setTimeout(() => {
      window.dispatchEvent(new Event('open-register-popup'))
    }, 1200)
  },
  beforeUnmount() {
    this.observers.forEach(ob => ob.disconnect())
  },
  methods: {
    // 스크롤 진입 시 섹션이 부드럽게 등장하는 모션
    setupReveal() {
      this.$nextTick(() => {
        const root = this.$el
        if (!root) return

        // 일반 섹션: 아래→위 페이드업 (hero는 LCP 위해 제외)
        const generic = Array.from(root.querySelectorAll(
          '.prem-head, .sec-inner, .layout-img, .community-img, ' +
          '.unit-tabs-wrap, .unit-current, .unit-stack, .dp-section-inner'
        ))
        generic.forEach(el => el.classList.add('reveal'))

        // 프리미엄 TOP6: 좌우 지그재그 슬라이드-인
        const prem = Array.from(root.querySelectorAll('.prem-item'))
        const all = [...generic, ...prem]

        // IntersectionObserver 미지원 시 즉시 노출 (안전장치)
        if (!('IntersectionObserver' in window)) {
          generic.forEach(el => el.classList.add('reveal--in'))
          prem.forEach(el => el.classList.add('is-in'))
          return
        }

        const ob = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const el = entry.target
              el.classList.add(el.classList.contains('prem-item') ? 'is-in' : 'reveal--in')
              ob.unobserve(el)
            }
          })
        }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' })

        all.forEach(el => ob.observe(el))
        this.observers.push(ob)
      })
    },
    scrollToForm() {
      this.$refs.secRegister?.scrollIntoView({ behavior: 'smooth' })
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.formData[field] = this.formData[field].replace(/[^0-9]/g, '')
      if (this.formData[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    toggleConsultLater() {
      this.formData.consultLater = !this.formData.consultLater
      if (this.formData.consultLater) {
        this.formData.visitDate = ''
        this.formData.visitTime = ''
      }
    },
    formatVisitDate(dateStr) {
      if (!dateStr) return ''
      const days = ['일','월','화','수','목','금','토']
      const d = new Date(dateStr)
      const y = dateStr.slice(0, 4)
      const m = dateStr.slice(5, 7)
      const dd = dateStr.slice(8, 10)
      return `${y}.${m}.${dd}(${days[d.getDay()]})`
    },
    async submitForm() {
      if (!this.formData.consultLater) {
        if (!this.formData.visitDate || !this.formData.visitTime) {
          alert('방문일과 시간을 선택하거나 "상담 후 결정"을 선택해주세요.')
          return
        }
      }
      if (!this.formData.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      const consultTime = this.formData.consultLater
        ? '상담 후 결정'
        : `${this.formatVisitDate(this.formData.visitDate)} ${this.formData.visitTime}`
      this.isSubmitting = true
      try {
        await registerCustomer({
          name: this.formData.name,
          phone: `${this.formData.phone1}${this.formData.phone2}${this.formData.phone3}`,
          consultTime,
          source: 'website'
        })
        this.isSubmitted = true

        // 네이버 전환 스크립트 - 신청완료(lead)
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_5a3399ef72b5'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
/* ===== 기본 ===== */
.detail-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #fff;
  overflow-x: hidden;
  padding-bottom: 120px;
}

/* ===== 스크롤 등장 모션 ===== */
.reveal {
  opacity: 0;
  transform: translateY(26px);
  transition: opacity 0.7s ease, transform 0.8s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: opacity, transform;
}

.reveal--in {
  opacity: 1;
  transform: none;
}

@media (prefers-reduced-motion: reduce) {
  .reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}

.dp-section-inner {
  max-width: 560px;
  margin: 0 auto;
  padding: 72px 28px;
}

.dp-num {
  display: inline-block;
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 48px;
  font-weight: 900;
  color: rgba(0, 0, 0, 0.06);
  line-height: 1;
  margin-bottom: 8px;
}

.dp-num.light {
  color: rgba(255, 255, 255, 0.1);
}

.dp-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 4px;
  text-transform: uppercase;
  color: #3f3536;
  margin-bottom: 16px;
}

.dp-eyebrow.light {
  color: rgba(255, 255, 255, 0.4);
}

.dp-section-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 28px;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 1.5;
  margin-bottom: 40px;
}

.dp-section-title strong {
  font-weight: 800;
}

.dp-section-title.light {
  color: rgba(255, 255, 255, 0.6);
}

.dp-section-title.light strong {
  color: #fff;
}

/* ===== 01. 메인 비주얼 ===== */
.dp-hero {
  width: 100%;
  line-height: 0;
}

.dp-hero-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 02. 프로젝트 스토리 (5씬) ===== */
.dp-story {
  background: linear-gradient(180deg, #2a2324 0%, #3f3536 100%);
  padding: 80px 0 100px;
  position: relative;
  overflow: hidden;
}

.dp-story::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image:
    radial-gradient(circle at 15% 12%, rgba(255, 211, 107, 0.10), transparent 40%),
    radial-gradient(circle at 85% 88%, rgba(255, 211, 107, 0.06), transparent 40%);
  pointer-events: none;
}

/* -- 섹션 헤더 -- */
.story-hero {
  text-align: center;
  padding: 0 28px 56px;
  position: relative;
  z-index: 1;
}

.story-hero-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 6px;
  color: rgba(255, 211, 107, 0.85);
  margin-bottom: 24px;
}

.story-hero-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 38px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.3;
  margin-bottom: 28px;
  letter-spacing: -1px;
}

.story-hero-title strong {
  font-weight: 900;
  background: linear-gradient(135deg, #fff 0%, #ffd36b 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.story-hero-divider {
  width: 56px;
  height: 3px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
  margin: 0 auto;
  border-radius: 2px;
}

/* -- 씬 카드 공통 -- */
.story-scene {
  position: relative;
  z-index: 1;
  max-width: 480px;
  margin: 24px auto;
  padding: 36px 28px;
  background: #fdfaf2;
  border-radius: 18px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.7s ease, transform 0.7s cubic-bezier(0.22, 1, 0.36, 1);
}

@media (max-width: 520px) {
  .story-scene {
    margin: 20px 16px;
    padding: 28px 22px;
  }
}

.story-scene.show {
  opacity: 1;
  transform: translateY(0);
}

.scene-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding-bottom: 18px;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(30, 58, 111, 0.12);
}

.scene-num {
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 28px;
  font-weight: 900;
  color: #3f3536;
  line-height: 1;
}

.scene-eyebrow {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 18px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.5px;
}

.scene-body {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  color: #2c2c2c;
}

.scene-body > * + * {
  margin-top: 18px;
}

.scene-body strong {
  font-weight: 800;
}

.scene-lead {
  font-size: 17px;
  font-weight: 500;
  line-height: 1.6;
  color: #555;
}

.scene-lead strong {
  font-weight: 800;
  color: #1a1a1a;
}

.scene-pivot {
  font-size: 19px;
  font-weight: 800;
  color: #3f3536;
  text-align: center;
  letter-spacing: -0.5px;
}

.scene-emphasis {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.6;
  letter-spacing: -0.3px;
}

.scene-emphasis strong {
  color: #3f3536;
  font-weight: 900;
}

.scene-quote {
  font-size: 17px;
  font-weight: 700;
  color: #c9a14a;
  text-align: center;
  letter-spacing: -0.3px;
  padding-bottom: 8px;
}

.scene-quote strong {
  color: #ff5757;
  font-weight: 900;
}

.scene-ctx-line {
  text-align: center;
  padding: 14px 16px;
  background: linear-gradient(135deg, rgba(30, 58, 111, 0.06) 0%, rgba(201, 161, 74, 0.08) 100%);
  border-radius: 10px;
  border-left: 3px solid #c9a14a;
}

.scene-finale {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.6;
  text-align: center;
  letter-spacing: -0.3px;
  padding: 16px;
  background: rgba(30, 58, 111, 0.05);
  border-radius: 10px;
}

.scene-finale strong {
  color: #3f3536;
  font-weight: 900;
}

/* SCENE 01: 10년 split */
.scene-split {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 22px 12px;
  background: #fff;
  border: 1px solid rgba(30, 58, 111, 0.1);
  border-radius: 14px;
}

.split-item {
  flex: 1;
  text-align: center;
}

.split-num {
  display: block;
  font-family: 'Paperlogy', sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #3f3536;
  line-height: 1.1;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.split-text {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  line-height: 1.5;
}

.split-text strong {
  font-weight: 900;
  color: #1a1a1a;
}

.split-divider {
  width: 1px;
  height: 56px;
  background: rgba(0, 0, 0, 0.1);
}

/* SCENE 02: 49층 빅넘 */
.scene-bignum {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 6px;
  padding: 22px 12px;
  background: linear-gradient(135deg, #3f3536 0%, #2a2324 100%);
  border-radius: 14px;
  position: relative;
  overflow: hidden;
}

.scene-bignum::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
}

.bignum-prefix,
.bignum-suffix {
  font-size: 16px;
  font-weight: 700;
  color: rgba(255, 211, 107, 0.95);
}

.bignum-num {
  font-family: 'Paperlogy', sans-serif;
  font-size: 64px;
  font-weight: 900;
  color: #fff;
  line-height: 1;
  letter-spacing: -2px;
  text-shadow: 0 2px 16px rgba(255, 211, 107, 0.35);
}

.bignum-unit {
  font-size: 24px;
  font-weight: 800;
  color: #fff;
  margin-right: 6px;
}

/* 일반 리스트 */
.scene-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.scene-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #444;
  border-left: 3px solid #3f3536;
}

.scene-list li + li {
  margin-top: 10px;
}

.scene-list li strong {
  font-weight: 800;
  color: #1a1a1a;
}

.list-icon {
  font-size: 18px;
  flex-shrink: 0;
}

/* SCENE 03: 체크리스트 */
.scene-checklist {
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(30, 58, 111, 0.08);
}

.scene-checklist li {
  position: relative;
  padding: 14px 16px 14px 46px;
  font-size: 15px;
  font-weight: 600;
  color: #2c2c2c;
  letter-spacing: -0.3px;
}

.scene-checklist li + li {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.scene-checklist li::before {
  content: '✓';
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background: #3f3536;
  color: #fff;
  font-size: 12px;
  font-weight: 900;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scene-checklist li strong {
  color: #3f3536;
  font-weight: 900;
}

/* SCENE 04: 상품 그리드 */
.product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.product-pill {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 18px 6px;
  background: linear-gradient(135deg, #3f3536 0%, #5a4d4e 100%);
  border-radius: 12px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.product-pill::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
}

.pill-cat {
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 211, 107, 0.95);
  letter-spacing: 1px;
}

.pill-area {
  font-family: 'Paperlogy', sans-serif;
  font-size: 22px;
  font-weight: 900;
  color: #fff;
  letter-spacing: -1px;
}

.feature-row {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.feature-item {
  flex: 1;
  text-align: center;
  padding: 12px 8px;
  background: #fff;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 800;
  color: #3f3536;
  border: 1px solid rgba(30, 58, 111, 0.15);
  letter-spacing: 1px;
}

/* SCENE 05: 마무리 + 혜택 */
.story-scene-final {
  background: linear-gradient(180deg, #fdfaf2 0%, #fff8e3 100%);
}

.scene-brand {
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 22px;
  font-weight: 900;
  color: #3f3536;
  text-align: center;
  letter-spacing: -1px;
  padding: 16px 12px;
  border-top: 2px solid #3f3536;
  border-bottom: 2px solid #3f3536;
}

.benefit-card {
  background: #fff;
  border-radius: 14px;
  padding: 30px 20px 20px;
  position: relative;
  box-shadow: 0 4px 20px rgba(30, 58, 111, 0.08);
}

.benefit-ribbon {
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(135deg, #ff5757, #ff8a3d);
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  padding: 7px 18px;
  border-radius: 50px;
  letter-spacing: -0.3px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(255, 87, 87, 0.35);
}

.benefit-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.benefit-list li {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 4px;
  font-size: 16px;
  font-weight: 600;
  color: #2c2c2c;
}

.benefit-list li + li {
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
}

.benefit-list li strong {
  font-weight: 900;
  color: #3f3536;
}

.benefit-icon {
  font-size: 22px;
  width: 28px;
  text-align: center;
  flex-shrink: 0;
}

.scene-warn {
  font-size: 16px;
  font-weight: 700;
  color: #555;
  text-align: center;
  line-height: 1.6;
}

.scene-warn strong {
  color: #ff5757;
  font-weight: 900;
}

.scene-cta {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 32px;
  background: linear-gradient(135deg, #3f3536, #2a2324);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 17px;
  font-weight: 800;
  letter-spacing: -0.3px;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(30, 58, 111, 0.4);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.scene-cta:active {
  transform: scale(0.97);
}

.cta-arrow {
  font-size: 20px;
  font-weight: 900;
}

/* ===== 공통 sec / sec-inner ===== */
.sec { position: relative; }
.sec-inner { padding: 80px 28px; }

.sec-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--gold, #c9a14a);
  margin-bottom: 20px;
}

.section-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 32px;
  line-height: 1.4;
}

/* ===== 프리미엄 TOP6 ===== */
.sec-premium {
  position: relative;
  background: linear-gradient(180deg, #2a2324 0%, #191415 100%);
  padding: 76px 0 88px;
  overflow: hidden;
}

.sec-premium::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 12% 8%, rgba(201, 161, 74, 0.12), transparent 42%),
    radial-gradient(circle at 88% 92%, rgba(201, 161, 74, 0.08), transparent 42%);
  pointer-events: none;
}

/* 헤더 */
.prem-head {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 28px 46px;
}

.prem-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 5px;
  color: #c9a14a;
  margin: 0 0 16px;
}

.prem-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 30px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.35;
  letter-spacing: -1px;
  margin: 0;
}

.prem-title strong {
  font-weight: 900;
  background: linear-gradient(135deg, #fff 0%, #e8c987 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.prem-title-line {
  width: 48px;
  height: 2px;
  background: linear-gradient(90deg, #c9a14a, #e8c987);
  margin: 22px auto 0;
  border-radius: 2px;
}

/* 리스트 */
.prem-list {
  position: relative;
  z-index: 1;
  max-width: 680px;
  margin: 0 auto;
  padding: 0 20px;
}

.prem-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 28px 26px;
  margin-bottom: 16px;
  background: rgba(255, 255, 255, 0.035);
  border: 1px solid rgba(201, 161, 74, 0.18);
  border-radius: 16px;
  overflow: hidden;

  /* 등장 전: 왼쪽에서 슬라이드-인 */
  opacity: 0;
  transform: translateX(-46px);
  transition: opacity 0.7s ease, transform 0.9s cubic-bezier(0.22, 1, 0.36, 1);
  will-change: opacity, transform;
}

/* 짝수 항목: 오른쪽에서 슬라이드-인 + 좌우 미러 */
.prem-item.is-right {
  flex-direction: row-reverse;
  text-align: right;
  transform: translateX(46px);
}

.prem-item.is-in {
  opacity: 1;
  transform: none;
}

/* 상단 골드 라인 (등장 시 점등) */
.prem-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(201, 161, 74, 0.7), transparent);
  opacity: 0;
  transition: opacity 0.6s ease 0.2s;
}

.prem-item.is-in::before {
  opacity: 1;
}

/* 대형 아웃라인 넘버 */
.prem-num {
  flex-shrink: 0;
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 62px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: -3px;
  color: transparent;
  -webkit-text-stroke: 1.4px rgba(201, 161, 74, 0.6);
}

/* 본문 */
.prem-content {
  flex: 1;
  min-width: 0;
}

.prem-cat {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 3px;
  color: #c9a14a;
  margin: 0 0 9px;
}

.prem-headline {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 18px;
  font-weight: 800;
  color: #fff;
  line-height: 1.4;
  letter-spacing: -0.5px;
  margin: 0 0 9px;
}

.prem-desc {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.6;
  letter-spacing: -0.2px;
  margin: 0;
}

@media (max-width: 520px) {
  .prem-title { font-size: 25px; }
  .prem-item {
    gap: 14px;
    padding: 22px 18px;
  }
  .prem-num { font-size: 48px; letter-spacing: -2px; }
  .prem-headline { font-size: 16px; }
  .prem-desc { font-size: 12px; }
}

@media (prefers-reduced-motion: reduce) {
  .prem-item {
    opacity: 1;
    transform: none;
    transition: none;
  }
}

/* ===== 단지배치도 ===== */
.sec-layout { background: #fafaf7; }
.sec-layout .sec-inner { padding: 40px 28px 16px; }

.layout-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 세대정보 ===== */
.sec-unit { background: #fff; }
.sec-unit .sec-inner { padding: 40px 28px 28px; }

/* 유닛 탭 가로 스크롤 */
.unit-tabs-wrap {
  margin: 0 -28px 18px;
  padding: 0 28px 4px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.unit-tabs-wrap::-webkit-scrollbar { display: none; }

.unit-tabs {
  display: inline-flex;
  flex-wrap: nowrap;
  gap: 8px;
  padding-right: 28px;
}

.unit-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: #f5f5f5;
  border: 1px solid transparent;
  border-radius: 999px;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #666;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.unit-tab:hover { background: #ececec; }

.unit-tab.active {
  background: var(--gold, #c9a14a);
  color: #1a1a1a;
  box-shadow: 0 6px 14px rgba(201, 161, 74, 0.3);
}

.unit-tab-tag {
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  background: #c9a14a;
  color: #fff;
  letter-spacing: -0.2px;
}

.unit-tab.active .unit-tab-tag {
  background: #ffd36b;
  color: #3f3536;
}

/* 기본/옵션 세그먼트 토글 */
.unit-mode {
  display: inline-flex;
  background: #f0f0f0;
  border-radius: 999px;
  padding: 4px;
  margin-bottom: 16px;
}

.unit-mode-btn {
  padding: 9px 22px;
  background: transparent;
  border: none;
  border-radius: 999px;
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #888;
  cursor: pointer;
  transition: all 0.2s ease;
  letter-spacing: -0.3px;
}

.unit-mode-btn.active {
  background: #1a1a1a;
  color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

/* 활성 유닛 라벨 */
.unit-current {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  padding-bottom: 14px;
  border-bottom: 1px solid #ececec;
}

.unit-current-name {
  font-family: 'Paperlogy', 'Roboto', sans-serif;
  font-size: 22px;
  font-weight: 900;
  color: #1a1a1a;
  letter-spacing: -1px;
}

.unit-current-tag {
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 11px;
  font-weight: 800;
  color: #fff;
  background: #c9a14a;
  padding: 3px 8px;
  border-radius: 4px;
  letter-spacing: -0.2px;
}

.unit-current-mode {
  margin-left: auto;
  font-family: 'Pretendard Variable', sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: #3f3536;
  background: rgba(30, 58, 111, 0.08);
  padding: 4px 10px;
  border-radius: 999px;
}

/* 평면도 + 디테일 스택 */
.unit-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.unit-figure {
  margin: 0;
  border: 1px solid #eee;
  border-radius: 12px;
  overflow: hidden;
  background: #fafafa;
}

.unit-cap {
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 3px;
  color: #888;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
}

.unit-img {
  width: 100%;
  height: auto;
  display: block;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ===== 커뮤니티 ===== */
.sec-community { background: #fafaf7; }
.sec-community .sec-inner { padding: 40px 28px 16px; }

.community-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 10. 방문예약 ===== */
.dp-register {
  background: var(--primary, #2e2823);
}

.dp-register-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.45);
  margin-top: -28px;
  margin-bottom: 36px;
}

.dp-form {
  max-width: 400px;
}

.dp-field {
  margin-bottom: 18px;
}

.dp-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
}

.dp-req { color: #e8a0a0; }

.dp-field input[type="text"],
.dp-field input[type="tel"] {
  width: 100%;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  font-family: var(--font-family);
  font-size: 15px;
  color: #1a1a1a;
  outline: none;
  transition: border-color 0.2s ease;
}

.dp-field input:focus { border-color: #fff; }
.dp-field input::placeholder { color: #bbb; }

.dp-phone {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dp-phone input {
  flex: 1;
  text-align: center;
  min-width: 0;
}

.dp-phone span {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  flex-shrink: 0;
}

.dp-time-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.dp-date-stack {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.dp-date-wrap {
  position: relative;
  width: 100%;
}

.dp-date-input {
  width: 100%;
  padding: 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #fff;
  font-family: var(--font-family);
  font-size: 14px;
  outline: none;
  color-scheme: dark;
  cursor: pointer;
}

.dp-date-input:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.dp-date-placeholder {
  position: absolute;
  top: 50%;
  left: 14px;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
  font-weight: 500;
  pointer-events: none;
  background: #3f3536;
  padding-right: 8px;
}

.dp-select {
  width: 100%;
  padding: 14px 36px 14px 14px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: #fff;
  font-family: var(--font-family);
  font-size: 14px;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23fff' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  cursor: pointer;
}

.dp-select:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.dp-select option {
  background: #3f3536;
  color: #fff;
}

.dp-later-btn {
  margin-top: 10px;
  width: 100%;
  padding: 13px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px dashed rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.8);
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dp-later-btn.active {
  background: #fff;
  border-style: solid;
  border-color: #fff;
  color: #3f3536;
  font-weight: 800;
}

.dp-time-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.dp-time-btn {
  padding: 12px 10px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dp-time-btn:hover { background: rgba(255, 255, 255, 0.14); }

.dp-time-btn.active {
  background: #fff;
  color: #3f3536;
  border-color: #fff;
  font-weight: 700;
}

.dp-visit { display: flex; gap: 8px; }

.dp-visit-wrap {
  flex: 1;
  position: relative;
}

.dp-visit-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #999;
  pointer-events: none;
  z-index: 1;
}

.dp-visit input,
.dp-visit select {
  width: 100%;
  padding: 14px 16px 14px 40px;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  font-family: var(--font-family);
  font-size: 14px;
  color: #1a1a1a;
  outline: none;
  appearance: none;
  transition: border-color 0.2s ease;
}

.dp-visit input:focus,
.dp-visit select:focus { border-color: #fff; }

.dp-visit select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
}

.dp-agree {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin: 24px 0 20px;
}

.dp-agree input[type="checkbox"] { display: none; }

.dp-check {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.dp-agree input:checked + .dp-check {
  background: #fff;
  border-color: #fff;
}

.dp-agree input:checked + .dp-check::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 5px;
  height: 9px;
  border: solid #3f3536;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.dp-submit {
  width: 100%;
  padding: 16px;
  background: #fff;
  color: #3f3536;
  border: none;
  border-radius: 12px;
  font-family: var(--font-family);
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.3s ease;
}

.dp-submit:active { background: #e8e8e8; }
.dp-submit:disabled { opacity: 0.6; cursor: not-allowed; }

.dp-success { text-align: center; padding: 40px 0; }

.dp-success-icon {
  width: 56px;
  height: 56px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #fff;
  margin: 0 auto 16px;
}

.dp-success h3 {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.dp-success p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

/* ===== 트리플 1초 역세권 ===== */
.sec-triple {
  background: linear-gradient(180deg, #2a2324 0%, #3f3536 100%);
  padding: 80px 0 90px;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.sec-triple::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 20% 20%, rgba(255, 211, 107, 0.12), transparent 45%),
    radial-gradient(circle at 80% 80%, rgba(255, 211, 107, 0.08), transparent 45%);
  pointer-events: none;
}

.triple-inner {
  position: relative;
  z-index: 1;
  max-width: 560px;
  margin: 0 auto;
  padding: 0 24px;
}

.triple-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 5px;
  color: rgba(255, 211, 107, 0.9);
  margin: 0 0 18px;
}

.triple-title {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 32px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: -1px;
  line-height: 1.3;
  margin: 0 0 18px;
}

.triple-title strong {
  font-weight: 900;
  background: linear-gradient(135deg, #fff 0%, #ffd36b 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.triple-divider {
  width: 56px;
  height: 3px;
  background: linear-gradient(90deg, #ffd36b, #ff8a3d);
  margin: 0 auto 36px;
  border-radius: 2px;
}

.triple-img {
  display: block;
  width: 100%;
  height: auto;
  margin: 0 auto 32px;
  border-radius: 14px;
}

.triple-lines {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  margin-bottom: 32px;
}

.line-card {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 211, 107, 0.2);
  border-radius: 14px;
  padding: 18px 20px;
  text-align: left;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 16px;
}

.line-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  padding: 8px 14px;
  font-weight: 900;
  font-size: 13px;
  border-radius: 20px;
  letter-spacing: -0.3px;
  white-space: nowrap;
}

.line-1 .line-badge { background: #0052a4; color: #fff; }
.line-2 .line-badge { background: #00a84d; color: #fff; }
.line-u .line-badge { background: #b0ce18; color: #1a1a1a; }

.line-name {
  font-size: 13px;
  font-weight: 800;
  color: #ffd36b;
  margin: 0 0 4px;
  letter-spacing: -0.3px;
}

.line-desc {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.5;
  margin: 0;
}

.triple-hook {
  font-family: 'Pretendard Variable', 'Pretendard', sans-serif;
  font-size: 17px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.7;
  letter-spacing: -0.4px;
  margin: 0;
}

.triple-hook strong { font-weight: 800; color: #fff; }
.triple-hook .triple-hl { color: #ffd36b; font-weight: 900; }

@media (max-width: 480px) {
  .sec-triple { padding: 60px 0 70px; }
  .triple-title { font-size: 26px; }
  .triple-hook { font-size: 15px; }
  .line-badge { min-width: 72px; font-size: 12px; padding: 7px 10px; }
}

/* ===== 상품 그리드 2컬럼 변형 ===== */
.product-grid-2 { grid-template-columns: repeat(2, 1fr); }

/* ===== checklist tight (4번 씬 전용) ===== */
.scene-checklist-tight li {
  padding: 12px 16px 12px 42px;
  font-size: 14px;
}

</style>
